module.exports = __webpack_public_path__ + "media/images/lp-doughnut-bottom-right-d927617d05c4374b257d03b756c4a844.svg";